import { render } from "./NewRestriction.vue?vue&type=template&id=24fa48b6&scoped=true"
import script from "./NewRestriction.vue?vue&type=script&lang=js"
export * from "./NewRestriction.vue?vue&type=script&lang=js"

import "./NewRestriction.vue?vue&type=style&index=0&id=24fa48b6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fa48b6"]])

export default __exports__